import { Trash } from '@griply/assets';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Question } from 'shared/assets/icons';
import { Colors, Sizes } from 'shared/components/ui/icon-button';
import { Tooltip } from 'shared/components/ui/tooltip';
import { helpCenterLink } from 'shared/constants';
import { Paths } from 'shared/routes/paths';

import * as Styled from './bottom-bar.style';

export type BottomBarProps = {
  activePath?: Paths;
};

export const BottomBar: React.FC<BottomBarProps> = ({ activePath }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const helpButtonRef = useRef<HTMLButtonElement>(null);
  const trashButtonRef = useRef<HTMLButtonElement>(null);

  const openHelpCenter = () => window.open(helpCenterLink, '_blank');
  const navigateToTrash = () => navigate(Paths.Trash);

  const isTrashActive = activePath === Paths.Trash;

  return (
    <Styled.Container>
      <Styled.IconButton
        ref={helpButtonRef}
        icon={Question}
        onClick={openHelpCenter}
        size={Sizes.Medium}
        color={Colors.Default}
      />
      <Tooltip
        referenceElement={helpButtonRef}
        label={t('context-menus.user.labels.help-center')}
        delay={400}
      />

      <Styled.IconButton
        ref={trashButtonRef}
        icon={Trash}
        onClick={navigateToTrash}
        size={Sizes.Medium}
        color={Colors.Default}
        $active={isTrashActive}
      />
      <Tooltip
        referenceElement={trashButtonRef}
        label={t('general.menu.navigation.todo.trash')}
        delay={400}
      />
    </Styled.Container>
  );
};
